/**
 * ----------------------------------------------------------------------------------------------------------------------
 * SIZE ADVISOR — ajout sur mesure Leo & Ugo (ne fait pas partie du thème Prestige)
 * ----------------------------------------------------------------------------------------------------------------------
 *
 * Pose trois questions et recommande une taille, à partir des mensurations du guide des tailles de la boutique.
 * Les valeurs ne sont PAS écrites ici : elles viennent des attributs data- posés par snippets/size-advisor.liquid,
 * pour qu'il n'y ait qu'un seul endroit à corriger si le guide change.
 *
 * Règle de calcul, reprise de la maquette :
 *   - le tour de poitrine donne une taille, le tour de taille une autre ;
 *   - on retient la plus grande des deux, pour ne jamais recommander trop petit ;
 *   - le porté souhaité décale d'un cran : près du corps -1, ample +1.
 */
if (!window.customElements.get('size-advisor')) {
  const COUPES = [
    { id: 'pres', nom: 'Près du corps', ecart: -1 },
    { id: 'dessine', nom: 'À ma taille', ecart: 0 },
    { id: 'ample', nom: 'Ample', ecart: 1 },
  ];

  class SizeAdvisor extends HTMLElement {
    connectedCallback() {
      if (this.rendu) {
        return;
      }

      this.rendu = true;
      this.sizes = this.getAttribute('data-sizes').split(',');
      this.bust = this.getAttribute('data-bust').split(',');
      this.waist = this.getAttribute('data-waist').split(',');
      this.french = this.getAttribute('data-french').split(',');

      // Rien n'est présélectionné : afficher une taille avant que la cliente ait répondu l'induirait en erreur.
      this.choix = { bust: null, waist: null, fit: 'dessine' };

      this.remplir('bust', this.bust);
      this.remplir('waist', this.waist);
      this.remplir('fit', COUPES.map((coupe) => coupe.nom), COUPES.map((coupe) => coupe.id));

      this.addEventListener('click', this.onChoix.bind(this));
      this.querySelector('[data-pick]').addEventListener('click', this.onValider.bind(this));
      this.update();
    }

    remplir(champ, libelles, valeurs) {
      const conteneur = this.querySelector(`[data-field="${champ}"] .size-advisor__choices`);

      conteneur.replaceChildren(
        ...libelles.map((libelle, index) => {
          const bouton = document.createElement('button');

          bouton.type = 'button';
          bouton.className = 'size-advisor__choice';
          bouton.dataset.field = champ;
          bouton.dataset.value = valeurs ? valeurs[index] : String(index);
          bouton.textContent = libelle;

          return bouton;
        })
      );
    }

    onChoix(event) {
      const bouton = event.target.closest('.size-advisor__choice');

      if (!bouton) {
        return;
      }

      const champ = bouton.dataset.field;
      this.choix[champ] = champ === 'fit' ? bouton.dataset.value : Number(bouton.dataset.value);
      this.update();
    }

    /**
     * L'indice de la taille recommandée, ou null tant que les deux mensurations ne sont pas renseignées
     */
    get recommandation() {
      if (this.choix.bust === null || this.choix.waist === null) {
        return null;
      }

      const coupe = COUPES.find((c) => c.id === this.choix.fit) || COUPES[1];
      const base = Math.max(this.choix.bust, this.choix.waist);

      return Math.min(this.sizes.length - 1, Math.max(0, base + coupe.ecart));
    }

    update() {
      this.querySelectorAll('.size-advisor__choice').forEach((bouton) => {
        const champ = bouton.dataset.field;
        const valeur = champ === 'fit' ? bouton.dataset.value : Number(bouton.dataset.value);

        bouton.classList.toggle('is-selected', this.choix[champ] === valeur);
      });

      const index = this.recommandation;
      const resultat = this.querySelector('[data-result]');
      const attente = this.querySelector('[data-pending]');
      const valider = this.querySelector('[data-pick]');

      resultat.hidden = index === null;
      attente.hidden = index !== null;
      valider.hidden = index === null;

      if (index === null) {
        return;
      }

      const coupe = COUPES.find((c) => c.id === this.choix.fit) || COUPES[1];
      const taille = this.sizes[index];

      this.querySelector('[data-result-size]').textContent = `Taille ${taille}`;
      this.querySelector('[data-result-french]').textContent = `soit un ${this.french[index]} français`;
      this.querySelector('[data-result-text]').textContent =
        `Votre tour de poitrine indique la taille ${this.sizes[this.choix.bust]}, `
        + `votre tour de taille la taille ${this.sizes[this.choix.waist]}. Nous retenons la plus grande`
        + (coupe.ecart === 0 ? '.' : `, ajustée pour un porté ${coupe.nom.toLowerCase()}.`);

      valider.textContent = `Choisir la taille ${taille}`;
      valider.dataset.size = taille;
    }

    /**
     * Coche la taille conseillée dans le sélecteur de la fiche produit, puis referme la pop-up.
     */
    onValider(event) {
      const taille = event.currentTarget.dataset.size;
      const pave = Array.from(document.querySelectorAll('.variant-picker .block-swatch')).find(
        (label) => label.textContent.trim() === taille
      );

      if (pave) {
        pave.click();
      }

      this.closest('x-modal')?.hide();
    }
  }

  window.customElements.define('size-advisor', SizeAdvisor);
}
